module.exports = function getResource(label, vars = []) {
    const resources = {
        installmentsWithAfterpayAndKlarna: `ou quatre paiements de ${vars[0]} avec`,
        or: 'ou ',
        testCardDiscount: `or ${vars[0]} off your Sephora order when you open and use a Sephora Credit Card today.¹`,
        test: 'Earn 2x Beauty Insider Points with every $1 spent using your Sephora Credit Card at Sephora',
        testSeeDetails: 'Voir les détails',
        learnMore: 'En savoir plus'
    };

    return resources[label];
};
